import { useCallback, useEffect, useState } from "react";
import useSession from "./utils/Session";
import { Alert, Skeleton, Statistic } from "antd";
import NavigationManager from "utils/NavigationManager";

import "./utils/i18n";
import "./styles/antd/antd.min.css";
import "./styles/App.css";

import { formStep, personalAreaStep } from "./types/StepEnums";
import { PagesEnum } from "./types/PagesEnum";
import ChangePassword from "./components/ChangePassword/ChangePassword";
import LoginForm from "./components/LoginForm/LoginForm";
import AreaRiservata from "./pages/AreaRiservata/AreaRiservata";
import { AuthRepository } from "./core/data";
import { message } from "antd";

import NavBar from "./components/Navbar/Navbar";
import axios, { InternalAxiosRequestConfig } from "axios";
import { Navigate, Route, Routes, useSearchParams } from "react-router-dom";
import { getCurrentPageName, pagesDictionaryFromEnum, pagesEnumFromPageName, terminateSession } from "./utils/NavigationHelper";
import Prenotazione from "./pages/Prenotazione/Prenotazione";
import { Pagamento } from "./pages";
// import ReactGA from "react-ga4";
import { IHSBLocationStateManager } from "./core/interfaces/data/IHSBLocationManager";
import { setLogin, setChangePasswordRequired, resetLogin } from "core/redux/features/session/sessionSlice";
import NormativaPrivacy from "pages/NormativaPrivacy/NormativaPrivacy";
import { resetDataForm } from "core/redux/features/dataForm/dataFormSlice";
import { performAsyncFunction } from "utils/AsyncFunctionUtility";
import Notifiche from "pages/Notifiche/Notifiche";
import FooterWrapper from "components/FooterWrapper/FooterWrapper";
import { StorageHelper } from "utils/SessionStorageHelper";
import { Enhanced, IReactComponentBase } from "utils/ReactUtils";
import { InstallPrompt } from "components/InstallPrompt/InstallPrompt";
import Help from "pages/Help/Help";

const App: React.FC<IReactComponentBase> = ({ t, sessionInfo, i18n, navigate, dispatch, location, handleError, dataForm }, ...props) => {
	const { GoBack, GoOn, GoToPage, GoToStep, GoToHomepage } = NavigationManager(sessionInfo);

	const [resetPage, setResetPage] = useState<boolean>(false);

	const [resetForm, setResetForm] = useState<boolean>(false);
	const [loadingPage, setLoadingPage] = useState<boolean>(false);

	const [searchParams, setSearchParams] = useSearchParams();

	const { initSession, OnFinishSession } = useSession(sessionInfo);

	var onRefresh = useCallback((e: BeforeUnloadEvent) => {
		// e.preventDefault();
		// salvo che la pagina è stata ricaricata

		StorageHelper.setItem("PAGE_UNMOUNTED", JSON.stringify(true));
		// ReactGA.reset();
		// e.returnValue = "test";
	}, []);

	const SetLogged = useCallback(
		(logged: boolean, nominativoUtente: string | undefined) => {
			dispatch(setLogin([logged, nominativoUtente]));
		},
		[dispatch]
	);

	const SetChangePasswordRequired = useCallback(
		(needChangePassword: boolean) => {
			dispatch(setChangePasswordRequired(needChangePassword));
		},
		[dispatch]
	);

	useEffect(() => {
		let qsManipulated = false;
		for (const param of searchParams.entries()) {
			StorageHelper.setItem(param[0], param[1]);
			searchParams.delete(param[0]);
			qsManipulated = true;
		}
		if (qsManipulated) {
			location.search = "";
			setSearchParams(searchParams, { replace: true, state: location.state });
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [searchParams]);

	useEffect(() => {
		let pageUnmounted = StorageHelper.getItem("PAGE_UNMOUNTED");
		// a causa di problemi di gestione del window.sessionStorage
		// è stato introdotto anche il controllo che lo state sia valorizzato (esclude il primo caricamento)
		// console.log(location);
		if (pageUnmounted && JSON.parse(pageUnmounted) && location?.state) {
			StorageHelper.removeItem("PAGE_UNMOUNTED");
			StorageHelper.clear();
			//GoToPage(PagesEnum.ReservationForm, formStep.Home, { backNavAllowed: true, reset: true });
			if(location.state.newStep!==undefined && location.state.newStep as any <= 3) StorageHelper.removeItem("PAGE_UNMOUNTED");
			else GoToPage(PagesEnum.ReservationForm, formStep.Home, { backNavAllowed: true, reset: true });

			return;
		} else {
			StorageHelper.removeItem("PAGE_UNMOUNTED");
		}

		let pagErrorOccurred = StorageHelper.getItem("PAGE_ERROR_OCCURRED");
		if (pagErrorOccurred) {
			StorageHelper.removeItem("PAGE_ERROR_OCCURRED");
		}

		let canGoBack = location.state?.backNavAllowed === undefined || location.state!.backNavAllowed!;

		if (!(location?.state ?? false)) {
			document.body.classList.remove("noscroll");

			if (!canGoBack) {
				GoOn();
			} else {
				setResetForm(true);
				setResetPage(false);
				setLoadingPage(true);
				GoToHomepage(setLoadingPage);
			}
		} else {
			document.body.classList.remove("noscroll");
			let state = location.state as IHSBLocationStateManager;
			var step = Number.parseInt(state.newStep ?? "0");
			//se voglio resettare la pagina o è occorso un errore allora perdispongo le variabili di stato per il reset
			if ((!resetPage && (state?.reset ?? false)) || pagErrorOccurred) {
				setResetPage(true);
			//	COMMENTATO per risolvere il blocco alla navigazione a seguito del reset password
			//	Il return fa uscire da questo ciclo e, SE RICARICO la pagina allora entro nel successivo
			//	ma altrimenti rimanevo sospeso?
				return;
			} else if (resetPage) {
			// }
			// if (resetPage) {
				let page = pagesEnumFromPageName[getCurrentPageName(location.pathname)];
				if (step === formStep.Home && page === PagesEnum.ReservationForm && !(state?.reset ?? false)) {
					setResetForm(true);
					setResetPage(false);
					// torno in avanti di uno per sovrascrivere le operazioni effettuate
					navigate({ pathname: `${location.pathname}`, search: location.search }, { state: state });
				} else {
					setResetPage(true);
					navigate(-1);
					return;
				}
			}

			if (!canGoBack && !resetPage) {
				GoOn();
			}

			//$ALC: CAUSA DEL LOOP IN FASE DI LOGIN "IN CORSA", eliminarlo non sembra compromettere la funzionalità dell'app
			// if (step !== sessionInfo.step) {
			// 	dispatch(setStep(step));
			// }
			if (
				resetPage ||
				(location.pathname === `/${pagesDictionaryFromEnum[PagesEnum.ReservationForm]}` && Number.parseInt(state.newStep ?? "0") === formStep.Home)
			) {
				setResetPage(false);
			}
		}

		if (!sessionInfo.isLogged)
			performAsyncFunction(async () => {
				const loggin = await AuthRepository.SessionCheckAuth();
				if (loggin.IsLogged) {
					SetLogged(loggin.IsLogged, loggin.nomeUtente);
				}
			}, handleError);

		// sezione per intercettare la dismissione della pagina corrente
		window.addEventListener("beforeunload", onRefresh);
		window.addEventListener("unload", onRefresh);

		return () => {
			window.removeEventListener("beforeunload", onRefresh);
			window.removeEventListener("unload", onRefresh);
		};
	}, [GoOn, GoToHomepage, GoToPage, SetLogged, handleError, location.pathname, location.search, location.state, navigate, onRefresh, resetPage, sessionInfo.isLogged]);


	const OnLoginSuccess = (nominativoUtente: string) => {
		SetLogged(true, nominativoUtente);

		//GoToPage(PagesEnum.PersonalArea);
		var destinationPage = location.state.pageSender;
		if (destinationPage) {
			GoToPage(destinationPage);
		} else {
			navigate(-1);
		}
	};

	const goToReservation = () => {
		setLoadingPage(true);

		// if (sessionInfo.step !== formStep.Home) {
		// 	GoToPage(PagesEnum.ReservationForm, sessionInfo.step, { reset: true });
		// } else {

		// COMMENTATO SOPRA PER EVITARE CHE SI BLOCCHI QUANDO DAGLI STEP DI PRENOTAZIONE
		// FACCIO LOGIN E TORNO AGLI STEP DI PRENOTAZIONE
		//
		GoToPage(PagesEnum.ReservationForm, formStep.Home, { reset: true });
		// }
		setTimeout(function () {
			dispatch(resetDataForm());
		}, 0);

		setLoadingPage(false);
	};

	const goToPersonalArea = (repl: boolean = false) => {
		setLoadingPage(true);

		if (sessionInfo.isLogged) {
			GoToPage(PagesEnum.PersonalArea, personalAreaStep.datiUtente);
			setLoadingPage(false);
		} else {
			performAsyncFunction(async () => {
				await initSession();
				GoToPage(PagesEnum.Login, personalAreaStep.datiUtente, { pageSender: PagesEnum.PersonalArea }, repl);
				setLoadingPage(false);
			}, handleError);
		}

		setTimeout(function () {
			dispatch(resetDataForm());
		}, 0);
	};

	const goToNotification = () => {
		setLoadingPage(true);
		performAsyncFunction(async () => {
			if (sessionInfo.isLogged) {
				GoToPage(PagesEnum.Notification, formStep.Home);
			} else {
				await initSession();

				GoToPage(PagesEnum.Login, formStep.Home, { PageSender: PagesEnum.Notification });
			}
			setTimeout(function () {
				dispatch(resetDataForm());
			}, 0);

			OnFinishSession(sessionInfo.step as number, false, true);
			setLoadingPage(false);
		}, handleError);
	};

	const goToHelp = () => {
		setLoadingPage(true);
		performAsyncFunction(async () => {
			// if (sessionInfo.isLogged) {
			GoToPage(PagesEnum.Help, formStep.Home);
			// } else {
			// 	await initSession();

			// 	GoToPage(PagesEnum.Login, formStep.Home, { PageSender: PagesEnum.Notification });
			// }
			// setTimeout(function () {
			// 	dispatch(resetDataForm());
			// }, 0);

			OnFinishSession(sessionInfo.step as number, false, true);
			setLoadingPage(false);
		}, handleError);
	};

	const ShowLogoutSuccess = () => {
		let hide = message.info("Logout effettuato.");

		setTimeout(() => {
			hide();
		}, 1500);
	};

	const OnLogout = async () => {
		const succ = await AuthRepository.Logout();
		if (succ) {
			//  SetLogged(false, undefined);
			dispatch(resetLogin());
			ShowLogoutSuccess();
			AuthExpiredRedirect();
		}
	};

	const AuthExpiredRedirect = () => {
		switch (location.pathname) {
			case pagesDictionaryFromEnum[PagesEnum.ReservationForm]:
				if ((sessionInfo.step as number) >= formStep.Authentication) {
					GoToStep(formStep.Authentication);
				} else {
					goToReservation();
				}
				break;
			case pagesDictionaryFromEnum[PagesEnum.PersonalArea]:
				GoToPage(PagesEnum.PersonalArea);
				break;
			default:
				goToReservation();
				break;
		}
		setTimeout(function () {
			dispatch(resetDataForm());
		}, 0);
	};

	/**
	 * Quando il cookie di sessione è scaduto riporto al Login
	 */
	const OnLoginExpired = () => {
		message.info("Autenticazione scaduta. Tornerai alla pagina principale...");
		const loadingBlock = document.getElementById("loading");
		if (loadingBlock) loadingBlock.style.display = "block";

		setTimeout(() => {
			if (loadingBlock) loadingBlock.style.display = "none";
			// goToReservation();
			GoToHomepage(setLoadingPage);
		}, 3000);
	};

	// const CancelToken = axios.CancelToken;
	// const source = CancelToken.source();
	const controller = new AbortController();

	axios.interceptors.request.use((request: InternalAxiosRequestConfig) => {
		// request.cancelToken = source.token;
		request.signal = controller.signal;
		return request;
	});

	axios.interceptors.response.use(
		(response) => {
			return response;
		},
		(error) => {
			// if (!axios.isCancel(error)) {
			if (error?.response?.status === 401) {
				OnLoginExpired();
				// source.cancel();
				controller.abort();
			}
			return error.response;
			// }
		}
	);

	const OnChangePasswordRequest = (changePasswordRequired: boolean) => {
		SetChangePasswordRequired(changePasswordRequired);

		GoToPage(PagesEnum.ChangePassword, sessionInfo.step);
	};

	const OnChangePasswordComplete = () => {
		SetChangePasswordRequired(false);
		if (StorageHelper.hasItem("resetPasswordToken")) {
			StorageHelper.removeItem("resetPasswordToken");
			goToPersonalArea(true);
		} else {
			GoBack(true);
		}
	};

	const getScheletonActive = () => {
		return (resetPage ?? true) || StorageHelper.getItem("PAGE_ERROR_OCCURRED") || !i18n.isInitialized;
	};

	return (
		<>
			<NavBar
				onReservedAreaClick={goToPersonalArea}
				onLogoutClick={OnLogout}
				onNewReservationClick={goToReservation}
				onNotificationClick={goToNotification}
				onHelpClick={goToHelp}
				float={true}
				timer={
					sessionInfo.sessione && (sessionInfo.step as number) >= formStep.Authentication && sessionInfo.step !== formStep.ResultPrenotazione ? (
						<>
							{/* <span>{window.CONFIG.REACT_APP_CONTATTI.TELEFONO}</span> */}
							<span>
								{t("sessionInfo.tempoSessione")} &nbsp;
								<Statistic.Countdown
									format="mm"
									value={sessionInfo.sessione.expiredIn}
									onFinish={() =>{terminateSession(GoToPage,OnFinishSession,sessionInfo)}}
									className={"ant-card ant-card-bordered ant-card-hoverable ant-card-body timer-fixed"}
									suffix=" min"
								/>
							</span>
						</>
					) : (
						<span>{/*window.CONFIG.REACT_APP_CONTATTI.TELEFONO*/}</span>
					)
				}
			></NavBar>

			<div className="App" id="app">
				<div className="app-container" id="app-container">
					<div className="app-content-box">
						<Routes>
							<Route
								path="/"
								element={
									StorageHelper.hasItem("resetPasswordToken") ? (
										<Navigate
											to={`/${pagesDictionaryFromEnum[PagesEnum.ChangePassword]}${location.search}`}
											state={{ newStep: personalAreaStep.datiUtente, from: location }}
											replace={true}
										/>
									) : (
										<Navigate
											to={`/${pagesDictionaryFromEnum[PagesEnum.ReservationForm]}${location.search}`}
											state={{ newStep: formStep.Home, from: location }}
											replace={true}
										/>
									)
								}
							></Route>
							<Route
								path={pagesDictionaryFromEnum[PagesEnum.ReservationForm]}
								element={
									getScheletonActive() || loadingPage ? (
										<Skeleton active />
									) : (
										<Prenotazione resetForm={resetForm} setResetForm={setResetForm} OnChangePasswordRequest={OnChangePasswordRequest}></Prenotazione>
									)
								}
							></Route>
							<Route
								path={pagesDictionaryFromEnum[PagesEnum.PersonalArea]}
								element={
									getScheletonActive() ? (
										<Skeleton active />
									) : (
										<div className="reservedArea">
											<div className="title item">
												<span>{t("reservedArea.title")}</span>
											</div>
											<AreaRiservata />
										</div>
									)
								}
							/>
							<Route
								path={pagesDictionaryFromEnum[PagesEnum.ChangePassword]}
								element={
									getScheletonActive() ? (
										<Skeleton active />
									) : (
										<ChangePassword
											OnSubmit={() => {
												GoBack(true);
											}}
											OnChangePasswordEnd={OnChangePasswordComplete}
											ChangePasswordRequired={sessionInfo.changePasswordRequired}
										/>
									)
								}
							/>
							<Route
								path={pagesDictionaryFromEnum[PagesEnum.Login]}
								element={
									getScheletonActive() ? (
										<Skeleton active />
									) : sessionInfo.isLogged ? (
										<Navigate
											to={`/${pagesDictionaryFromEnum[PagesEnum.PersonalArea]}${location.search}`}
											state={{ newStep: formStep.Home, from: location }}
											replace={true}
										/>
									) : (
										<LoginForm OnChangePasswordRequest={OnChangePasswordRequest} OnLoginSuccess={OnLoginSuccess} />
									)
								}
							/>
							<Route
								path={pagesDictionaryFromEnum[PagesEnum.Payment]}
								element={<>{getScheletonActive() ? <Skeleton active /> : <Pagamento OnFinishSession={OnFinishSession} />}</>}
							/>
							<Route path={pagesDictionaryFromEnum[PagesEnum.PrivacyPolicy]} element={<NormativaPrivacy></NormativaPrivacy>} />

							<Route path={pagesDictionaryFromEnum[PagesEnum.Notification]} element={<Notifiche GoBack={GoBack} />} />

							<Route path={pagesDictionaryFromEnum[PagesEnum.Help]} element={getScheletonActive() ? <Skeleton active /> : <Help />} />

							<Route path="*" element={<Alert message={t("errorMessages.pageNotFound")} type="error" showIcon banner />}></Route>
						</Routes>
					</div>
				</div>
			</div>

			<div className="footer-hsb-container">
				<FooterWrapper />
			</div>

			<InstallPrompt></InstallPrompt>
		</>
	);
};

export default Enhanced(App, { componentNamespace: "App" });